var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#DFF8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9281 13.5H15.0844C14.6642 13.5 14.2612 13.6669 13.9641 13.9641C13.6669 14.2612 13.5 14.6642 13.5 15.0844V30.9281C13.5 31.3483 13.6669 31.7513 13.9641 32.0484C14.2612 32.3455 14.6642 32.5125 15.0844 32.5125H18.2531V30.9281H15.0844V19.8375H32.5125V15.0844C32.5125 14.6642 32.3455 14.2612 32.0484 13.9641C31.7513 13.6669 31.3483 13.5 30.9281 13.5ZM15.0844 18.2531V15.0844H30.9281V18.2531H15.0844Z",
    fill: "#05BC86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9321 27.1498H27.2318C27.5907 27.1498 27.8816 27.4383 27.8816 27.7996C27.8816 28.1586 27.5932 28.4495 27.2318 28.4495H25.2821C25.1037 28.4495 24.942 28.3782 24.8246 28.262C24.7051 28.142 24.6324 27.981 24.6324 27.8056V25.1943C24.6324 24.8387 24.9208 24.5504 25.2822 24.5504C25.6411 24.5504 25.9321 24.8435 25.9321 25.1943L25.9321 27.1498ZM27.4458 21.5006C30.5658 22.3366 32.4172 25.5436 31.5813 28.6636C30.7453 31.7835 27.5383 33.635 24.4183 32.7991C21.2984 31.9631 19.4467 28.7561 20.2828 25.6361C21.1188 22.5161 24.3258 20.6645 27.4458 21.5006ZM27.1094 22.756C24.6827 22.1058 22.1885 23.5459 21.5383 25.9724C20.888 28.3992 22.3281 30.8933 24.7547 31.5436C27.1814 32.1938 29.6756 30.7538 30.3259 28.3271C30.9761 25.9004 29.5361 23.4062 27.1094 22.756Z",
    fill: "#05BC86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedRun);
export default __webpack_public_path__ + "static/media/sched-run.5b54fa1cf97731fff044be6b2d4f9e46.svg";
export { ForwardRef as ReactComponent };